(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["f-header"] && !Shopify.designMode) return;
  try {
    
class HeaderWrapper extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.header = document.getElementById('shopify-section-f-header');
		this.exitTimer = null;
		this.onEnterHandler = this.onEnter.bind(this);
		this.onLeaveHandler = this.onLeave.bind(this);
		this.addEventListener('mouseenter', this.onEnterHandler);
		this.addEventListener('mouseleave', this.onLeaveHandler);
	}

	disconnectedCallback() {
		this.removeEventListener('mouseenter', this.onEnterHandler);
		this.removeEventListener('mouseleave', this.onLeaveHandler);
	}

	onEnter() {
		this.preventClose = true;
		this.header.classList.add('is-active');
		clearTimeout(this.exitTimer);
	}

	onLeave() {
		this.exitTimer = setTimeout(() => {
			this.header.classList.remove('is-active');
		}, 400);
	}

}
customElements.define('f-header-wrapper', HeaderWrapper);

const announcementBarStorageValue = sessionStorage.getItem('show_announcement_bar');
const showAnnouncementBar = !announcementBarStorageValue || announcementBarStorageValue === 'true';

if (showAnnouncementBar) {
  const announcements = document.querySelectorAll('.announcement-bar');
    if (announcements.length) announcements.forEach(el => {
      el.style.display = 'block';
    });
}

const announcementClose = document.querySelector('.announcement-bar-close');
if (announcementClose) {
  const handler = () => {
    const announcements = document.querySelectorAll('.announcement-bar');
    if (announcements.length) announcements.forEach(el => {
      el.style.display = 'none';
      sessionStorage.setItem('show_announcement_bar', false);
    });
  }
  announcementClose.addEventListener('click', handler);
  announcementClose.addEventListener('touchstart', handler);
}

  } catch(e) { console.error(e); }
})();
})();
